export class EmailAndPhoneAlreadyInUseError extends Error {
  public constructor() {
    super()

    this.message = 'errors.emailAndPhoneAlreadyInUse'
  }
}
